import _ from 'lodash';

const PriceFormatter = (price: number): string => {
  const numPrice = _.toNumber(price);
  const validPrice = _.isFinite(numPrice) ? numPrice : 0;

  const [intPart, decPart = ''] = validPrice.toString().split('.');

  const formattedIntPart = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',');

  return decPart ? `${formattedIntPart}.${decPart}` : formattedIntPart;
};

export default PriceFormatter;
